import React from "react";
import { Navigate } from "react-router-dom";
import { useFusion, useFeatureFlagsLoaded } from "../../contexts/FeatureFlagsContext";
import { useRBAC } from "../../hooks/useRBAC";

/**
 * Direct-URL gate for /Fusion, matching the nav tab exactly: Features:Fusion on, and not an
 * assignment-scoped user (no breadth anywhere in the org — SELF-scoped, or only a deal/BU
 * contributor/approver), whom the nav sends to My Tasks instead. Renders nothing until the flags
 * have loaded so an opt-in flag is not mistaken for "off" on the first render.
 */
const FusionRouteGuard = ({ children }) => {
  const enabled = useFusion();
  const loaded = useFeatureFlagsLoaded();
  const { isAssignmentScopedOnly } = useRBAC();
  if (!loaded) return null;
  if (!enabled) return <Navigate to="/dashboard" replace />;
  if (isAssignmentScopedOnly()) return <Navigate to="/my-tasks" replace />;
  return children;
};

export default FusionRouteGuard;
